export const generateUUID = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
};

export const createReconSSE = (sseToken, SSE_BASE_URL, onMessage, onError) => {
  const url = `${SSE_BASE_URL}/api/sse/${sseToken}`;

  console.log("SSE Starting point");

  const eventSource = new EventSource(url);

  console.log(
    "SSE object created:",
    url,
    "readyState:",
    eventSource.readyState
  );

  return new Promise((resolve, reject) => {
    let opened = false;

    eventSource.onopen = () => {
      opened = true;
      console.log('SSE onopen fired, readyState:', eventSource.readyState);
      resolve(eventSource);
    };

    eventSource.onmessage = (event) => {
      console.log("RAW SSE:", event.data);
      try {
        const data = JSON.parse(event.data);
        console.log("REAL SSE DATA:", data);
        if (data.status === 'done' || data.status === 'Pass') {
          console.log("Recon completed via SSE, recon_id:", data.recon_id);
        }
        onMessage(data, eventSource);
      } catch (err) {
        console.log('Ignoring non-json SSE message:', event.data);
      }
    };

    eventSource.onerror = (e) => {
      const rs = eventSource?.readyState;
      console.log(
        "SSE onerror fired, readyState:", rs,
        "timestamp:", new Date().toISOString()
      );
      if (rs === 2) {
        console.log("SSE permanently closed (readyState 2)");
        eventSource.close();
        if (!opened) reject(new Error('SSE connection failed permanently'));
      }
      if (onError) onError(e, rs, eventSource);
    };
  });
};